var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner c-survey__bg--blue" }, [
    _c(
      "div",
      { staticClass: "c-survey__content c-survey__content--padding-ltr" },
      [
        _c("main", {
          staticClass: "c-survey__html",
          domProps: { innerHTML: _vm._s(_vm.pageFour.content) },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "c-survey__content c-survey__content--padding c-survey__content--white-bg c-survey__content--page-four",
      },
      [
        _vm.pageFour.imageFile
          ? _c("img", {
              staticClass: "c-survey__page-four-image",
              attrs: { src: _vm.pageFour.imageFile },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("main", {
          staticClass: "c-survey__html",
          domProps: { innerHTML: _vm._s(_vm.pageFour.question) },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "c-survey__actionbutton-row c-survey__actionbutton-row--center",
          },
          [
            _c("ActionButton", {
              attrs: {
                title: _vm.pageFour.answerNoLabel,
                buttonAction: "questionNo",
                colour: "red",
              },
            }),
            _vm._v(" "),
            _c("ActionButton", {
              attrs: {
                title: _vm.pageFour.answerYesLabel,
                buttonAction: "questionYes",
                colour: "green",
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "c-survey__content-spacer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }